/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Space, Button, Card, Popconfirm, Layout, Table, Input } from "antd";

import { ALL_VENDOR, DELETE_VENDOR } from "../../../constants/api";

function VendorTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  // GET LIST
  const getList = () => {
    setLoading(true);

    const successFn = function (data) {
      if (data.status === true) {
        const formattedData = data.data.map((row, index) => ({
          key: index,
          ID: index + 1,
          VendorCode: row.vendor_code,
          Name: row.name,
          Phone: row.phone,
          Action: (
            <Space>
              <Button
                onClick={() => navigate("/laundry/vendor/edit/" + row.id)}
                block
              >
                Edit
              </Button>

              <Popconfirm
                title="Delete Vendor"
                description="Are you sure to delete this vendor?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));

        setState(formattedData);
        setFilteredState(formattedData);
      } else {
        setState([]);
        setFilteredState([]);
      }
      setLoading(false);
    };

    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };

    getAPI(ALL_VENDOR, successFn, errorFn, {});
  };

  // DELETE
  const deleteData = (id) => {
    setLoading(true);

    const successFn = function (data) {
      if (data.status === true) {
        displayMessage(SUCCESS_MESSAGE, data.message);
        getList();
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Vendor");
    };

    postAPI(DELETE_VENDOR, { id }, successFn, errorFn);
  };

  // SEARCH
  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((data) =>
      data.Name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "ID",
      width: 70,
    },
    {
      title: "Vendor Code",
      dataIndex: "VendorCode",
      width: 150,
    },
    {
      title: "Vendor Name",
      dataIndex: "Name",
      width: 200,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 150,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Manage Laundry Vendors"
          extra={
            <Space>
              <Input
                placeholder="Search by Vendor Name"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/laundry/vendor/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
          bordered
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 600 }}
          />
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default VendorTable;
